import { LOCAL_STORAGE_KEYS } from 'src/constants/local-storage';

function storageKey(userId: string): string {
  return `${LOCAL_STORAGE_KEYS.CLIENT_PORTAL_PORTFOLIO_SPLASH_DISMISSED}:${userId}`;
}

export function isPortfolioSplashDismissed(userId: string | null | undefined): boolean {
  if (typeof window === 'undefined' || userId === null || userId === undefined || userId === '') return false;
  return localStorage.getItem(storageKey(userId)) === 'true';
}

export function dismissPortfolioSplash(userId: string | null | undefined): void {
  if (typeof window === 'undefined' || userId === null || userId === undefined || userId === '') return;
  localStorage.setItem(storageKey(userId), 'true');
}
